import {Component,Input,OnChanges, OnInit, OnDestroy} from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CdkDragDrop, DragDrop, moveItemInArray, transferArrayItem, CdkDropList, CdkDrag } from '@angular/cdk/drag-drop';
import { PlantType, Navigation, LineTeam, SelectTeam, Version } from '../../shared/models/type-list';
import { TeamService } from 'src/app/team-edit/services/team.service';
import { Observable, Subscription} from 'rxjs';
import { pluck, switchMap } from 'rxjs/operators';
import { SelectedService } from '../services/selected.service';
import { NgFor, NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'view-select',
    templateUrl: './view-select.component.html',
    styleUrls: ['./view-select.component.scss'],
    imports: [CdkDropList, NgFor, CdkDrag, NgIf, MatButton]
})
export class ViewSelectComponent  implements OnChanges, OnInit, OnDestroy {
  currentNav: Navigation = {
    plant_name: '',
    line: '',
    subline: '',
    team_id: 0,
    version_id: 0
  }

  @Input()
    plantname ="" ;  
  @Input()
   line  = "";
  @Input()
   subline = "";
  teamSubscription: Subscription;
  selectionSubscription: Subscription;
  teamlist : SelectTeam[] = [];
  done : SelectTeam[] = []; 
  orgTeamList: SelectTeam[] = []
  teamstosave : boolean = false
  
  @Input()
  multi_team = false;
  constructor( 
    private route: ActivatedRoute,
    private router: Router,
    private teamService: TeamService,
    private selectedService:SelectedService) {

   }

  ngOnChanges(): void {
    console.log(' The value of done array ',this.done)
    if (this.done.length > 1){
      console.log(' Setting team to save ')
      this.teamstosave = true
    }

    this.getTeamList() 
  }

  ngOnInit(): void {
    const savedTeams = this.selectedService.getSelectedTeamsValue();
    if(savedTeams && savedTeams.length > 0) {
      this.done = savedTeams;
    }

    this.selectionSubscription = this.selectedService.getSelectedTeams().subscribe((teams) => {
      this.done = teams ? teams.slice() : [];
    })
  }
  
  getTeamList(){
    let teamObservable: Observable<SelectTeam[]> = 
    this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.teamService.getTeamsWithVersions(this.plantname, this.line, this.subline, 'true','true')),
        pluck('Body'));
 
    if (this.teamSubscription) this.teamSubscription.unsubscribe();
     let count =1
    this.teamSubscription = teamObservable.subscribe((out) => {
      out.map((ele:any)=>ele.uniq_id= (ele.subline.split(' ').join('')).toLowerCase()+'_'+(count++))

      this.teamlist = out      
      const doneIds = new Set(this.done.map(d => d.uniq_id));
      this.teamlist = this.teamlist.filter(item => !doneIds.has(item.uniq_id));
      this.orgTeamList = out
      console.log(this.teamlist)
      console.log(this.orgTeamList)

    })
 
  }
 

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
    this.selectedService.updateSelectedTeams(this.done);
  }


  viewTeams(){
    console.log(' Submit Teams to Multi-View ', this.done)
    let selectedTeams = JSON.stringify(this.done)
    this.router.navigate(['/multiteamwork'], { queryParams: { teamlist: selectedTeams}})
  }

  clearDone(){
    this.teamlist = [];
    this.orgTeamList = [];
    this.done = [];
    this.selectedService.clearSelections();
    this.selectedService.updateSelectedTeams([]);
    //this.getTeamList();
  }

  ngOnDestroy(): void {
    if (this.teamSubscription) this.teamSubscription.unsubscribe();
    if (this.selectionSubscription) this.selectionSubscription.unsubscribe();
  }

  disableTeam(team: SelectTeam){
    let teamSelected = this.done.filter(sTeam => sTeam.team_id === team.team_id)
    return teamSelected.length > 0;
  }
}



